// src/components/Loader.tsx
export default function Loader() {
  return (
    <div className="flex flex-col justify-center items-center py-10 space-y-4">
      {/* Loader spinner */}
      <div className="h-10 w-10 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>

      {/* Message */}
      <span className="text-blue-600 font-medium text-center">
        Please wait a moment while we search for loan offers.
      </span>
    </div>
  );
}
